import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SidebarsIconTooltip } from '../Sidebar/sidebarTooltip/SidebarsIconTooltip';
import { circleColor, IconProps, strokeColor } from './icons.utils';

export const AnalyticsIcon: React.FC<IconProps> = ({
  className,
  active,
  tooltip = '',
}): JSX.Element => {
  const [hover, setIsHover] = useState(false);
  const location = useLocation();

  const onEnter = () => {
    setIsHover(true);
  };
  const onLeave = () => {
    setIsHover(false);
  };

  const isAnalytics =
    !location.pathname.includes('overview') &&
    !location.pathname.includes('team-analytics') &&
    (location.pathname.includes('analytics') ||
      location.pathname.includes('personalq') ||
      location.pathname.includes('performanceq'));

  const circleFill =
    hover && !active && !isAnalytics
      ? '#cdd5e5'
      : circleColor(active || isAnalytics);

  const fillCol =
    active || isAnalytics ? strokeColor(active || isAnalytics) : 'none';

  const strokeCol =
    active || isAnalytics ? strokeColor(active || isAnalytics) : '#cdd5e5';

  const underscore =
    active || isAnalytics ? (
      <rect
        x="4.2"
        y="20.7"
        width="8.34831"
        height="2.05081"
        rx="1.0254"
        fill={strokeColor(active || isAnalytics)}
      />
    ) : (
      <></>
    );

  return (
    <div onMouseEnter={onEnter} onMouseLeave={onLeave}>
      <SidebarsIconTooltip isActive={hover} label={tooltip} />
      <svg
        width="20"
        height="26"
        viewBox="-5 -2 27 22.2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <circle
          cx="8.7"
          cy="9.2"
          r="12.5"
          fill={circleFill}
          style={
            active || isAnalytics
              ? {}
              : { transitionDuration: '0.1s', opacity: '0.2' }
          }
        />
        <rect
          x="4.5"
          y="8.5"
          width="7.00002"
          height="4"
          rx="0.5"
          transform="rotate(90 4.5 8.5)"
          stroke={strokeCol}
          fill={fillCol}
        />
        <rect
          x="15.5"
          y="3.82031"
          width="11.6792"
          height="4"
          rx="0.5"
          transform="rotate(90 15.5 3.82031)"
          stroke={strokeCol}
          fill={fillCol}
        />
        <rect
          x="10"
          y="0.5"
          width="15"
          height="4"
          rx="0.5"
          transform="rotate(90 10 0.5)"
          stroke={strokeCol}
          fill={fillCol}
        />
        {underscore}
      </svg>
    </div>
  );
};
